import { render, staticRenderFns } from "./keywordOptimize.vue?vue&type=template&id=3d243624&scoped=true"
import script from "./keywordOptimize.vue?vue&type=script&lang=js"
export * from "./keywordOptimize.vue?vue&type=script&lang=js"
import style0 from "./keywordOptimize.vue?vue&type=style&index=0&id=3d243624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d243624",
  null
  
)

export default component.exports